(ns ui.hyperframes-templates.register
  "UI register of the hyperframes-templates slice: the catalog page
   under /ui/hyperframes-templates and the action handlers of the
   editor2 templates sidebar. Requiring `ui.hyperframes-templates.composition`
   installs the stage rendering of template clips."
  (:require [ui.hyperframes-templates.actions :as actions]
            [ui.hyperframes-templates.composition]
            [ui.hyperframes-templates.page :as page]))

(def register
  (concat [page/page]
          actions/handlers))
